// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"39f1cbaf","345":"3b53517f","370":"3b53517f"}[chunkId] + ".chunk.css";
};